import React ,{useState} from 'react';
import { connect } from 'react-redux';
import KuposHelmet from '../../../common/KuposHelmet';
import HeroSection from '../../common/HeroSection/HeroSection';
import getIcons from '../../functions/getIcons/getIcons';
import ThemeNineTitle from '../common/ThemeNineTitle';

const data = [
  {
    title: 'Equipaje',
    des: `<p>Se entenderá por equipaje los artículos de uso personal de un pasajero, tales como vestuario, calzado, artículos de tocador, etc., que no excedan los 30 kilos ni los 180 decímetros cúbicos en tramo nacional y 20 kilos en tramo Internacional. En cuanto al embarque de otros elementos (artículos deportivos, electrónicos, etc.), este será evaluado según corresponda. Se considera como equipaje el peso y volumen total permitido por pasajero, independientemente del número de bultos. </p>
         <p class="bold-text"> Equipaje de mano: </p> 
         <p>Equipaje que lleva el pasajero en la cabina, bajo su custodia y responsabilidad. </p>
         <p class="bold-text">Peso y dimensión permitida: </p> 
         <p>El equipaje de mano debe ser una pieza de no más de 10 kilos y que no exceda los 100 centímetros (45 x 35 x 20). </p>
         <p class="bold-text">Equipaje de mano adicional: </p> 
         <p>Artículos como chaqueta, cámara fotográfica pequeña, laptop, pueden ser transportados adicionalmente a lo antes indicado, sin que bloqueen los pies ni el libre tránsito por los pasillos.</p>
         `,
    active: false,
  },

  {
    title: 'Tiempo de presentación de reclamos',
    des: `
           <p> Durante las primeras 24 horas desde la llegada a su destino.</p>
          `,
    active: false,
  },

  {
    title: 'Exceso de equipaje',
    des: `
    <p> En los servicios rurales e interurbanos (nacionales), cada pasajero tendrá derecho a llevar, libre de pago, hasta 30 kilos y en tramo Internacional 20 kilos. Si se sobrepasa este límite, se considerará como exceso de equipaje, lo cual estará afecto a un cobro y sujeto a disponibilidad para su transporte y correcto embalaje.</p>
    `,
    active: false,
  },

  {
    title: 'Transporte de animales',
    des: `
           <p> Buses Ahumada no cuenta con este servicio.</p>
          `,
    active: false,
  },

  {
    title: 'Perros lazarillos:',
    des: `
           <p> Los perros guías (lazarillos) de personas no videntes podrán acompañar gratuitamente a su titular a bordo del bus.</p>
          `,
    active: false,
  },

  {
    title: 'Declaración de especies',
    des: `
           <p> Si el valor de el o los artículos que lleva un pasajero supera las 5 UTM, este debe hacer una declaración de equipaje por el transporte de dicho artículo. Buses Ahumada se encuentra facultado para solicitar, si es necesario, la documentación que acredite su valor.</p>
          `,
    active: false,
  },
];

const ThemeNineBaggageTnCScreen = props => {

  const [state, setState] = useState(data);
  const [selected, setSelected] = useState(state[0]);

  const handleToggle = item => {
    const newState = state.map(d => {
      // d.active = d.title === item.title ? true : false;
      d.active = d.title === item.title &&  !d.active;
      return d;
    });
    setState(newState);
    setSelected(item);
  };

  const createMarkup = data => {
    return {
      __html: data,
    };
  };

  return props.home.operator ? (
    <div className="themes-theme-nine-baggage-tnc-screen">
      <KuposHelmet />
      <div style={{ position: 'relative', marginTop: -20 }}>
        <HeroSection
          // height={'30vh'}
          heroImage={getIcons('tncBaggageBanner')}
          title={'Condiciones de equipaje'}
          description={'Home / Términos y condiciones / Condiciones de equipaje'}
        />
      </div>

      <ThemeNineTitle title={'Condiciones de transporte de equipaje'} />

      <div className="baggage-container">
        <div className='baggage-details'>
          <p>
            Un equipaje se considera bajo la custodia, cuidado y responsabilidad de{' '}
            <span className="bold-text">Buses Ahumada Ltda.</span> desde el momento en que es
            etiquetado y subido al maletero del bus hasta cuando es entregado, en las mismas
            condiciones en que fue recibido, en el destino.<br></br>
            <span className="bold-text">
              A continuación todas las condiciones para el transporte de equipaje:
            </span>
          </p>
        </div>
        <div className='baggage-terms'>
        {state.map((val, i) => {
          return (
            <div className="single-item" key={i}>
              <div
                className={`header ${val.active ? 'hide-bg' : 'show-bg'}`}
                onClick={() => handleToggle(val)}
              >
                <img
                  className="arrow"
                  src={val.active ? getIcons('baggageMinus') : getIcons('baggagePlus')}
                  alt=""
                  width={"10px"}
                />
                <span className={`title ${val.active ? 'bold-text' : ''}`}>{val.title}</span>
                
              </div>

              {/* Selected Item */}
              {val.active ? (
                <div className="selected-item">
                  {/* {val.des && val.des.length > 0
                    ? val.des.map((d, i) => {
                        return (
                          <div className="description" key={i}>
                            <span>{d.des}</span>
                            <br />
                            <br />
                          </div>
                        );
                      })
                    : null} */}
                   <div dangerouslySetInnerHTML={createMarkup(val.des)} />
                </div>
              ) : null}
            </div>
          );
        })}

           
        </div>
      </div>
    </div>
  ) : null;
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

export default connect(mapStateToProps, {})(ThemeNineBaggageTnCScreen);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeNine/ThemeNinePages/ThemeNineBaggageTnCScreen.js